import { Component } from "react";
import styles from './index.less'
class ComBlock extends Component{
    constructor(props){
        super(props); 
    }
    render(){
        const {title,padding='8px',background='var(--adm-color-background)',children}=this.props
        //console.log('this.props',this.props);
        return <div>
            <div className={styles.demoBlock}>
                <div className='title' style={{"margin-bottom": "10px"}}>{title}</div>
                <div
                    className={styles.main}
                    style={{
                    padding: padding,
                    background: background,
                    }}
                >
                    {children}
                </div>
                </div>
        </div>
    } 
}
export default ComBlock;
